import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useLanguage } from "../../../../Translations/LenguageContext";
import DeleteRecordModal from "../../../ViewComponents/DeleteRecordModal";
import { useParams } from "react-router-dom";

const isObject = (val) => typeof val === "object" && val !== null;
const isTimestamp = (value) => value instanceof Date || !isNaN(Date.parse(value)); // Check if the value is a timestamp

const OpenTableData = ({ tableData, fetchTable, currentPage }) => {
    const { t } = useLanguage();
    const user_id = sessionStorage.getItem("user_id");
    const { project_id, db_id, coll_id } = useParams();
    const [expandedData, setExpandedData] = useState(null);
    const [expandedRecordId, setExpandedRecordId] = useState("");
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [recordObject, setRecordObject] = useState({});

    let allKeys = Array.from(
        new Set(tableData.flatMap((item) => Object.keys(item)))
    );

    allKeys = allKeys.includes("_id")
        ? ["_id", ...allKeys.filter((key) => key !== "_id")]
        : allKeys;

    const handleNestedClick = (key, value) => {
        setExpandedData({ key, value });
    };

    const closePanel = () => setExpandedData(null);

    const fetchRecords = () => {
        if (user_id && db_id && coll_id) {
            fetchTable(user_id, db_id, coll_id);
        }
    };

    const handleOpenDelete = (recordId) => {
        setShowDeleteModal(true);
        const selectedRecord = tableData.find((item) => item._id === recordId);
        if (selectedRecord) {
            const obj = {
                _id: {
                    db_id: db_id,
                    coll_id: coll_id,
                    item_id: selectedRecord._id,
                },
            };
            setRecordObject(obj);
        }
    };

    const handleClose = () => {
        setShowDeleteModal(false);
        setRecordObject({});
    };

    const getValueClass = (value) => {
        if (typeof value === "string") return "string_val";
        if (typeof value === "number") return "num_val";
        if (typeof value === "boolean") return "bool_val";
        if (Array.isArray(value)) return "array_val";
        if (isObject(value)) return "object_val";
        if (isTimestamp(value)) return "timestamp_val";
        return "";
    };

    return (
        <div className="table_container_view">
            <div className="table_col_cont">
                <table className="table_view_tab">
                    <thead>
                        <tr>
                            <th key={""} className="col_table_view_hader"></th>
                            {allKeys.map((key) => (
                                <th key={key} className="col_table_view_hader">
                                    {key}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.map((item, index) => (
                            <tr key={item._id || index} className="col_table_view">
                                <td className="cell_table_view">
                                    <p className="object_number">{(currentPage - 1) * 50 + index + 1}</p>

                                </td>
                                {allKeys.map((key) => {
                                    const value = item[key];

                                    const displayValue = isObject(value)
                                        ? Array.isArray(value)
                                            ? `${value.length} item${value.length !== 1 ? "s" : ""}`
                                            : <span className="object_cell">Object <i className="fa-solid fa-chevron-right"></i></span>
                                        : JSON.stringify(value);


                                    return (
                                        <td
                                            key={key}
                                            className={`cell_table_view ${getValueClass(value)}`}
                                            onClick={() => {
                                                handleNestedClick(key, value);
                                                setExpandedRecordId(item._id);
                                            }}
                                        >
                                            {displayValue}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className={`data_preview ${expandedData ? "data_preview_opened" : ""}`}>
                <div className="header_data_preview">
                    <p className="data_prev_id">_id: {expandedRecordId}</p>
                    <button onClick={closePanel} className="data_preview_btn_close">
                        <i className="fa-solid fa-x"></i>
                    </button>
                </div>
                {expandedData && (
                    <div>
                        <pre className="data_prev_body">
                            <p className="key_prev_data">{expandedData.key}: {JSON.stringify(expandedData.value, null, 2)}</p>
                        </pre>
                    </div>
                )}
            </div>
            {/* <DeleteRecordModal
                show={showDeleteModal}
                handleClose={handleClose}
                recordObject={recordObject}
                fetchRecords={fetchRecords}
                endpoint={"delete_collection_record"}
                record_type={"Delete"}
                message="This action CANNOT be undone. It will permanently delete the resource and all associated data."
            /> */}
        </div>
    );
};

export default OpenTableData;


